import React, { useState } from 'react'
import { isNil } from 'ramda'
import moment from 'moment'
import PropTypes from 'prop-types'
import { useIntl, FormattedMessage } from 'react-intl'
import { Button, Typography } from '@material-ui/core'

import { SUBMIT } from 'app/constants/button'
import SubmitDialog from 'app/componentV4/Dialog/SubmitDialog'

const ReminderDate = (props) => {
  const {
    id,
    reminderDate,
    sentDate,
    isAction = false,
    onCancelReminder = () => {},
  } = props
  const { formatMessage } = useIntl()

  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      {isNil(reminderDate) ? (
        <Typography className="text-sky-600">
          <FormattedMessage
            id="timeline.detail.message.has.reminder"
            values={{
              time: moment(sentDate).format('LT'),
              date: moment(sentDate).format('MMM DD, YYYY'),
              b: (text) => <b>{text}</b>,
            }}
          />
        </Typography>
      ) : (
        <div className="flex justify-between items-center">
          <Typography className="text-14 text-primary">
            <FormattedMessage
              id="timeline.detail.message.reminder"
              values={{
                time: moment(reminderDate).format('LT'),
                date: moment(reminderDate).format('MMM DD, YYYY'),
                b: (text) => <b>{text}</b>,
              }}
            />
          </Typography>
          {isAction ? (
            <Button
              className="text-14 text-orange-500 normal-case py-0 h-0 hover:bg-transparent"
              disableRipple
              onClick={() => {
                setIsOpen(true)
              }}
            >
              {formatMessage({
                id: 'timeline.detail.message.button.cancle.reminder',
              })}
            </Button>
          ) : null}
        </div>
      )}
      <SubmitDialog
        id={`dialog-cancel-reminder-timeline`}
        open={isOpen}
        type={SUBMIT}
        title={formatMessage({
          id: 'timeline.detail.message.dialog.title.reminder',
        })}
        description={formatMessage({
          id: 'timeline.detail.message.dialog.description.reminder',
        })}
        submitText={formatMessage({
          id: 'text.yse.cancel',
        })}
        onSubmit={async () => {
          await onCancelReminder(id)
          setIsOpen(false)
        }}
        closeText={formatMessage({
          id: 'text.close',
        })}
        onClose={() => setIsOpen(false)}
      />
    </>
  )
}

ReminderDate.propTypes = {
  id: PropTypes.number,
  reminderDate: PropTypes.string,
  sentDate: PropTypes.string,
  isAction: PropTypes.bool,
  onCancelReminder: PropTypes.func,
}

export default ReminderDate
